import { inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const cookie = inject(CookieService);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  if (!isBrowser) {
    return false;
  }
  if (cookie.get('Bearer')) {
    return true;
  } else {
    if (isBrowser) {
      localStorage.setItem('prevUrl', window.location.href);
      router.navigate(['/login']);
    }
    return false;
  }
};
